export default {
  job_7004: {
    eventAPI: {
      cycles: '/tsaiShenWuLung/{taskId}/cycles',
      now: '/tsaiShenWuLung/{taskId}/now',
      history: '/tsaiShenWuLung/{taskId}/history/{cycle}'
    },
    rankTab: {
      label: '财神五龙',
      message: {
        currentLeaderBoard: '※榜单将于今日北京时间上午11:59结算。'
      },
      suffix: ['caiShen_Item', 'dragon_Item']
    }
  },
  job_7004_bind_jobid_1: {
    eventAPI: {
      cycles: '/buYuWang/{taskId}/cycles',
      now: '/buYuWang/{taskId}/now',
      history: '/buYuWang/{taskId}/history/{cycle}'
    },
    rankTab: {
      label: '捕鱼王',
      message: {
        currentLeaderBoard: '※榜单将自北京时间2020年11月7日中午12:00統計〜2020年11月14日上午11:59结算。'
      },
      suffix: ['fishKing_Item']
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/config.js